<template>
  <div>
    <v-card >
      <v-toolbar >
        <v-toolbar-title v-if="numNotValid ==='0'"color="green">Ready to import! </v-toolbar-title>
        <v-toolbar-title v-else-if="numNotValid!=='1'">Import Locations: {{numNotValid}} Locations are not valid </v-toolbar-title>
        <v-toolbar-title v-else>  Import Locations: {{numNotValid}} Location is not valid </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <h1 v-show="isLoading"> Loading ... </h1>
      <v-data-table :pagination.sync="pagination" :items="locationsToCheck" class="items" :headers="headers">
        <template slot="items" slot-scope="props">
          <td v-if="props.item.warning">
          <v-tooltip bottom mandatory flat class="ml-0">
            <v-icon slot="activator" left color="yellow">error</v-icon>

            <span>
              <v-list>
                <v-list-tile
                v-for="(warning, index) in props.item.warnings"
                :key="index"
                >
                <v-list-tile-title>{{warning}}</v-list-tile-title>
              </v-list-tile>
            </v-list>

          </span>
        </v-tooltip>
        </td>

          <td v-else-if="props.item.valid">
            <v-icon left color="green">check_circle</v-icon>
          </td>
          <td v-else>
            <v-tooltip bottom mandatory flat class="ml-0">
              <v-icon slot="activator" left color="red">highlight_off </v-icon>

              <span>
                <v-list>
                  <v-list-tile
                  v-for="(error, index) in props.item.errors"
                  :key="index"
                  >
                  <v-list-tile-title>{{error}}</v-list-tile-title>
                </v-list-tile>
              </v-list>

            </span>
          </v-tooltip>
        </td>
        <td> {{props.item.title}}</td>
        <td>
          <v-btn  color="orange darken-2 dark"  @click="openEditor(props.item)">
            <v-icon left small>build</v-icon>
            Edit
          </v-btn>
        </td>
        <td>
          <v-btn color="red" @click="skip(props.item)">
          <v-icon left small>remove_circle</v-icon>
          Skip
        </v-btn>
      </td>
      <td>
        <v-btn :disabled="!props.item.valid || isImporting" color="blue" @click="importOne(props.item)">
        <v-icon left small>arrow_forward</v-icon>
        Import
      </v-btn>
    </td>
    </tr>

  </template>
</v-data-table>

<v-card-actions>
  <v-btn :disabled= "allValid" color="primary" flat @click="startAutofix()">Autofix</v-btn>
  <v-btn :disabled= "!allValid" color="primary" flat @click="initiateImport()">Import all</v-btn>
  <v-btn flat color= "black" @click="initiateClose()">Cancel</v-btn>
</v-card-actions>
</v-card>


<v-dialog :max-width="320" v-model="editorOpen" lazy  :persistent="true">
  <v-card v-if="editorOpen">
    <v-card-text>
      <location-form ref="lf" v-model ="editingItem" :newLocationFlag= "newLocationFlag"  :locations= "allLocations" v-on:valid="validLocation=$event[0],warningLocation=$event[1], updateLocation()"></location-form>
    </v-card-text>
    <v-card-actions>
      <div v-if ="!newLocationFlag">
        <v-btn :disabled= "!validLocation" color="primary" flat @click="editorOpen = false, updateLocation()">Save</v-btn>
        <v-btn flat color= "black" @click="editorOpen = false, revertItem()">Cancel</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>

</div>
</template>
<script>
import _ from "lodash"
export default {
  name: "CSVInput",
  components: {
    locationForm: require("./LocationForm").default
  },
  props: ["newLocations", "locations", "inputOpen", "isImporting"],

  data() {
    return {
      valid: false,
      typeInput: "",
      locationsToCheck: [],
      editingItem: null,
      tempItem: null,
      editorOpen:false,
      validLocation: false,
      warningLocation: false,
      newLocationFlag:false,
      tempItem:{},
      search:"",
      currentIndex: null,
      allValid: false,
      locationErrors: [],
      locationWarnings:[],
      isLoading: false,
      pagination: {
        rowsPerPage: 10
},
      allLocations: this.newLocations.concat(this.locations),
    }
  },
  watch: {
    value(nv) {
      this.model = nv
    }
  },

  methods: {
    startAutofix(){
      this.isLoading= true
      let self=this
      setTimeout(function(){
        self.autoFixAll()
      },
      200)

    },

    autoFixAll(){

      let inValidcounter = 0
      var unvalidHeight = 0
      var unvalidLongitude = 0
      var unvalidLatitude = 0
      var unvalidEirp = 0
      while(!this.allValid){

      for(var i = 0 ; i<this.newLocations.length; i++){

        if(!this.checkForWhiteSpacesBeginEnd(this.newLocations[i].name)){
          var whiteSpaceIndices = this.getWhiteSpace(this.newLocations[i].name)
           if(whiteSpaceIndices[0] == 1)
           {
             this.newLocations[i].name = this.newLocations[i].name.slice(1,this.newLocations[i].name.length)
           }
           if(whiteSpaceIndices[whiteSpaceIndices.length-1] == this.newLocations[i].name.length){
             this.newLocations[i].name = this.newLocations[i].name.slice(0,this.newLocations[i].name.length-1)
           }
        }
        if(!this.checkForWhiteSpacesBeginEnd(this.newLocations[i].type)){

          var whiteSpaceIndices = this.getWhiteSpace(this.newLocations[i].type)
           if(whiteSpaceIndices[0] == 1)
           {
             this.newLocations[i].type = this.newLocations[i].type.slice(1,this.newLocations[i].type.length)
           }
           if(whiteSpaceIndices[whiteSpaceIndices.length-1] == this.newLocations[i].type.length){
             this.newLocations[i].type = this.newLocations[i].type.slice(0,this.newLocations[i].type.length-1)
           }
        }

      if(inValidcounter == 0 &&!this.validateHeight(this.newLocations[i].height)){
        unvalidHeight++
      }

      if(!this.validateRequired(this.newLocations[i].name)){
        var unfound = true
        var index = 1
        while(unfound){
          var tryName = "Location("+index.toString()+")"
          if(typeof(_.find(this.newLocations, ['name', tryName]))=="undefined")
          {
            this.newLocations[i].name = tryName
            unfound = false
          }
          else{
            index++
          }
        }

      }
      if(inValidcounter==0 && (!this.validateEirp(this.newLocations[i].eirp)||!this.validateRequired(this.newLocations[i].eirp))){
        unvalidEirp++
      }
      if(inValidcounter==0 && (!this.validateCoordLong(this.newLocations[i].longitude))){
        unvalidLongitude++
      }
      if(inValidcounter==0 && (!this.validateCoordLat(this.newLocations[i].latitude))){
        unvalidLatitude++
      }
      if(!this.validateRequired(this.newLocations[i].type)){

        this.newLocations[i].type = "Unspecified"
      }
      if(!this.checkforExistingName(this.newLocations[i].name)){
        var unfound = true
        let index = 1
        while(unfound){
          var tryName = this.newLocations[i].name + "("+index.toString()+")"
          if(typeof(_.find(this.newLocations, ['name', tryName]))=="undefined")
          {
            this.newLocations[i].name = tryName
            unfound = false
          }
          else{
            index++
          }
        }

      }
      /*if(!this.checkForDoubleWhiteSpaces(location.name)){
        valid = false
        errors.push('Name: No double white spaces')
      }
      */

      /*if(!this.checkForDoubleWhiteSpaces(location.type)){
        valid = false
        errors.push('Type: No double white spaces')
      }*/

    }
    this.locationsToCheck = []
    for(let i=0;i<this.newLocations.length;i++){
      let [valid, warning]=this.validate(this.newLocations[i])
      this.locationsToCheck.push({ warning: warning, valid: valid, title: this.newLocations[i].name, errors: this.locationErrors })

    }
    this.areAllValid()
    if(inValidcounter>20){
      this.$emit('unfixable',"")
      this.isLoading=false
      this.$emit("dispErrors",[unvalidEirp.toString(),unvalidHeight.toString(),unvalidLatitude.toString(),unvalidLongitude.toString()])
      break
    }
    inValidcounter++
    }
      this.isLoading=false
    },

    initiateImport(){
      this.$emit('import',"")
    },

    initiateClose(){
      this.$emit('closeCard',"")
    },
    areAllValid(){
      if(typeof(_.find(this.locationsToCheck, ['valid', false]))=="undefined")
      this.allValid = true
      else {
        this.allValid = false
      }
    },
    validate(location){
      let valid = true
      let warning = false
      let errors = []
      let warnings = []
      this.locationErrors = []
      this.locationWarnings = []
      if(!this.validateHeight(location.height)){
        valid = false
        errors.push('Height: Only numbers greater zero and smaller 500')
      }
      if(!this.validateRequired(location.name)){
        valid = false
        errors.push('Name: Required')
      }
      if(!this.validateEirp(location.eirp)){
        valid = false
        errors.push('EiRP: Only numbers greater zero and smaller 25')
      }
      else if(location.eirp>14&&location.eirp<25){
        warnings.push('EiRP: Higher than threshold of 14')
        warning = true
      }
      if(!this.validateRequired(location.type)){
        valid = false
        errors.push('Type: Required')
      }
      if(!this.checkforExistingName(location.name)){
        valid = false
        errors.push('Name: Already existing in projects or in locations to be imported')
      }
      /*if(!this.checkForDoubleWhiteSpaces(location.name)){
        valid = false
        errors.push('Name: No double white spaces')
      }
      */
      if(!this.checkForWhiteSpacesBeginEnd(location.name)){
        valid = false
        errors.push('Name: No whitespaces at begin or end')
      }

      /*if(!this.checkForDoubleWhiteSpaces(location.type)){
        valid = false
        errors.push('Type: No double white spaces')
      }*/
      if(!this.checkForWhiteSpacesBeginEnd(location.type)){
        valid = false
        errors.push('Type: No whitespaces at begin or end')
      }

      if(!this.validateCoordLong(location.longitude)){
        valid = false
        errors.push('Longitude: Not a valid coordinate  (Between -180 and 180)')
      }

      if(!this.validateCoordLat(location.latitude)){
        valid = false
        errors.push('Latitude: Not a valid coordinate (Between -90 and 90)')
      }


      this.locationErrors = errors
      this.locationWarnings = warnings
      return [valid,warning]

    },
    revertItem(){

      this.newLocations[this.currentIndex].name = this.tempItem.name
      this.newLocations[this.currentIndex].type = this.tempItem.type
      this.newLocations[this.currentIndex].eirp = this.tempItem.eirp
      this.newLocations[this.currentIndex].height = this.tempItem.height

      this.locationsToCheck[this.currentIndex].title=this.tempItem.name
      let [valid,warn]=this.validate(this.tempItem)
      this.locationsToCheck[this.currentIndex].valid=valid
      this.locationsToCheck[this.currentIndex].warning=warn
      return
      this.locationsToCheck[this.currentIndex].errors = this.locationErrors
      this.locationsToCheck[this.currentIndex].warnings = this.locationWarnings
      this.areAllValid()
    },
    updateLocation(){
      this.locationsToCheck[this.currentIndex].title=this.editingItem.name
      this.locationsToCheck[this.currentIndex].valid=this.validLocation
      this.locationsToCheck[this.currentIndex].warning=this.warningLocation
      this.locationsToCheck[this.currentIndex].warnings=[]
      if(this.locationsToCheck[this.currentIndex].warning){
        this.locationsToCheck[this.currentIndex].warnings.push('EiRP: Higher than threshold of 14')
      }

      this.areAllValid()
    },

    checkForWhiteSpacesBeginEnd(input){
      var whiteSpaceIndices = this.getWhiteSpace(input)
      return !(whiteSpaceIndices[0] == 1 || whiteSpaceIndices[whiteSpaceIndices.length-1] == input.length)

    },
    checkForDoubleWhiteSpaces(input){

      var whiteSpaceIndices = this.getWhiteSpace(input)

        for(var i=0; i<whiteSpaceIndices.length-1;i++) {

          if (whiteSpaceIndices[i]+1 === whiteSpaceIndices[i+1]){
            return false

          }
       }
       return true
    },
   getWhiteSpace(s) {
     var indices = [];
       for(var i=0; i<s.length;i++) {
         if (s[i] === " ") indices.push(i+1);
      }
      return indices;
    },
    isValidHeight(input){
     return this.isNumberGreaterZero(input)&&input<500
    },
    isValidEirp(input){
      return this.isNumberGreaterZero(input)&&input<25
    },

    validateHeight(input){
      return this.isValidHeight(input)&&!!input
    },
    validateEirp(input){
      return this.isValidEirp(input)&&!!input
    },

    validateNumber(input){
      return this.checkForNumber(input)&&!!input
    },

    validateRequired(input){
      return !!input
    },

    validateCoordLat(coord){
      return(this.checkForNumber(coord)&&coord>=-90&&coord<=90)

    },

    validateCoordLong(coord){
      return(this.checkForNumber(coord)&&coord>=-180&&coord<=180)

    },
    validateNumberGreaterZero(input){
      return this.isNumberGreaterZero(input)&&!!input
    },
    isNumberGreaterZero(input){
      return this.checkForNumber(input)&&input>0
    },


    checkForNumber(input){
      if (!isNaN(parseFloat(input)))
      return true
      else
      return false

    },
    checkforExistingName(name){
      if(name==""){
        return true
      }
      let count=0
      for(let i =0; i<this.allLocations.length;i++){
        if(name == this.allLocations[i].name){
        count++
      }
    }
      if(count>1)
      return false
      else {
        return true
      }
    },
    importOne(location){
      let indexToImport= this.newLocations.indexOf(_.find(this.newLocations, ['name', location.title]))
      let locationToImport = this.newLocations.splice(indexToImport,1)
      this.locationsToCheck.splice(this.locationsToCheck.indexOf(location),1)
      this.$emit("importOne",locationToImport)
      if(this.locationsToCheck.length==0)
      this.initiateClose()
    },
    skip(location){
      this.locationsToCheck.splice(this.locationsToCheck.indexOf(location),1)
      if(this.locationsToCheck.length==0)
      this.initiateClose()
      let indexToDelete= this.newLocations.indexOf(_.find(this.newLocations, ['name', location.title]))
      this.newLocations.splice(indexToDelete,1)
      this.areAllValid()
    },
    openEditor(location) {

      let item=_.find(this.newLocations,['name', location.title])
      this.editingItem = item
      this.tempItem = {}
      Object.assign(this.tempItem, item)
      this.editorOpen = true
      this.currentIndex=this.locationsToCheck.indexOf(location)
      this.$nextTick(function () {
        this.$refs.lf.$refs.form.validate()
        })
    }
  },

  created(){

  },
  mounted(){
    this.locationsToCheck = []
    if(this.newLocations.length==0){
      this.initiateClose()
    }
      this.locationErrors= []
    for(let i=0;i<this.newLocations.length;i++){
      let [valid,warning]=this.validate(this.newLocations[i])

      this.locationsToCheck.push({warning: warning, valid: valid, title: this.newLocations[i].name, errors: this.locationErrors, warnings: this.locationWarnings })

    }
    this.$emit('checked',"")
    this.areAllValid()
  },

  computed:{
    numNotValid() {
      let inValidLocations = this.locationsToCheck.filter(location => !location.valid)
      return inValidLocations.length.toString()
    },

    headers() {
      return [
        {text: "valid", value: "valid", align: "left", sortable: true},
        {text: "Name", value: "title", align: "left", sortable: true},
        {text: "Edit Location", value: "edit", align: "left", sortable: false},
        {text: "Skip Location", value: "skip", align: "left", sortable: false},
        {text: "Import Location", value: "import", align: "left", sortable: false},
      ]
    },

  }

}
</script>

<style scoped>
.loading{
  z-index: 100
}
</style>



// WEBPACK FOOTER //
// src/components/CSVInput.vue